import { BellRing, Phone } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { REFURBISHED, CONTACT } from "@/lib/site";
import { scrollToSection } from "@/lib/scroll";

export default function Refurbished() {
  const notify = () => {
    window.dispatchEvent(
      new CustomEvent("prefill-devis", { detail: { message: REFURBISHED.notifyMessage } })
    );
    scrollToSection("#devis");
  };

  return (
    <section id="reconditionne" className="border-y border-line bg-ink py-24 lg:py-32">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Reconditionné"
          title={<>Une seconde vie, <span className="text-neon">bientôt en boutique</span></>}
          sub="Des appareils réparés et reconditionnés dans notre atelier de Saint-Pierre-en-Faucigny, garantis 1 an comme une réparation."
        />

        <Reveal delay={0.08}>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {REFURBISHED.chips.map((c) => (
              <span key={c} className="flex items-center gap-2 rounded-full border border-neon/25 bg-neon/5 px-4 py-2 text-xs font-semibold text-slate-200">
                <BellRing size={13} className="text-neon" />
                {c}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative mt-10 overflow-hidden rounded-3xl border border-neon/25 bg-gradient-to-br from-neon/10 via-transparent to-transparent p-8 text-center lg:p-14">
            <div className="pointer-events-none absolute left-1/2 top-[-120px] h-[240px] w-[460px] -translate-x-1/2 rounded-full bg-neon/15 blur-[90px]" aria-hidden="true" />
            <span data-testid="refurb-soon-badge" className="relative inline-flex items-center gap-2 rounded-full border border-neon/40 bg-night/80 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-neon">
              <span className="h-1.5 w-1.5 animate-pulse-glow rounded-full bg-neon" />
              Bientôt disponible
            </span>
            <h3 data-testid="refurb-coming-title" className="relative mt-5 font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">
              {REFURBISHED.comingTitle}
            </h3>
            <p className="relative mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
              {REFURBISHED.comingDesc}
            </p>
            <div className="relative mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button
                data-testid="refurb-notify-btn"
                onClick={notify}
                className="flex items-center gap-2 rounded-full bg-neon px-7 py-4 text-sm font-extrabold uppercase tracking-wider text-night chip-glow transition-transform duration-200 hover:scale-[1.04]"
              >
                <BellRing size={16} />
                Être prévenu de l'ouverture
              </button>
              <a
                data-testid="refurb-call-btn"
                href={CONTACT.phoneHref}
                className="flex items-center gap-2 rounded-full border border-line px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:border-neon hover:text-neon"
              >
                <Phone size={16} className="text-neon" />
                {CONTACT.phoneDisplay}
              </a>
            </div>
            <p className="relative mt-6 text-[11px] text-slate-500">
              En attendant, nous rachetons votre ancien téléphone — voir la section Rachat ci-dessus.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
